var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"confirm_modal",attrs:{"size":"xs","title":`Please confirm ${_vm.title}`,"ok-variant":"success"},on:{"ok":_vm.onConfirm,"hidden":_vm.onCancel,"cancel":_vm.onCancel}},[_c('template',{slot:"modal-ok"},[_vm._v(" Confirm ")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }